jQuery(function(){
    function enableSearch(form, input){
        jQuery('#'+form).submit(function(){
            var searchaction = null;    
            var val = jQuery("#"+input).val();
            if (typeof val === "undefined" || val.length < 3)
            {
                alert ("U dient minimaal 3 zoektekens te gebruiken.");
                return false;
            }
            else
            {
                var action = jQuery('#'+form).attr("action");
                
                // vertalen
                val = jQuery.trim(val);
                val = val.replace(/&/,'en').replace(/[^A-Za-z0-9 ]/g,'').replace(/\s{2,}/g,' ').replace(/\s/g, "-").toLowerCase();
                
                if (searchaction === null)
                {
                    searchaction = action;
                    var url = action+val+'/';
                }
                else
                {
                    var url = searchaction+val+'/';
                }
                jQuery('#'+form).attr("action", url);
                return true;
            }
        });    
    }
    
    enableSearch('search-form-default','search-word');
    enableSearch('search-form-content', 'search-word-content');
    
});